import { PrimaryWeaponAttackConfig } from 'game/core'

export const primary_weapon_attack_config: Array<PrimaryWeaponAttackConfig> = [
    {
        available: 0,
        energy: 'unknown',
        cooldown: 1
    }
]